

import { loginByUsername, getUserInfo, findToken, loginByMobile, logout } from '@/api/login'
import { getToken, setToken, removeToken, removeConsumerCondition, removeRedirectUrl, removePlatformUrl } from '@/utils/cookies'

const user = {
  state: {
    userInfo: '',
    token: getToken(),
    isLogin: false,
    host: process.env.SSO_WEB_URL,
    isActive: '0',
    quitQuanId:'',
    quitpcQuanId:'',
    favac: ""
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_ISLOGIN: (state, isLogin) => {
      state.isLogin = isLogin
    },
    SET_ISACTIVE: (state, isActive) => {
      state.isActive = isActive
    },
    SET_QUITQUANID: (state, quitQuanId) => {
      state.quitQuanId = quitQuanId
    },
    SET_PCQUITQUANID: (state, quitpcQuanId) => {
      state.quitpcQuanId = quitpcQuanId
    },
    SET_FAVAC: (state, favac) => {
      state.favac = favac
    },
  },
  actions: {
    // 获取token
    findToken ({ commit }) {       
      return new Promise((resolve, reject) => {
        findToken().then(response => {
          const token = response.data.data       
          commit('SET_TOKEN', token)
          setToken(token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户名登录
    LoginByUsername ({ commit }, userInfo) {
      const loginName = userInfo.loginName.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(loginName, userInfo.password).then(response => {
          const data = response.data
          // 说明登录成功了，给vuex设置token，放到Cookie
          const token = data.data
          //  && data.otherData === 'login'
          if (data.errorInfo === 'success' && token !== '') {
            commit('SET_TOKEN', token)
            setToken(token, userInfo.checked)
            // setConsumerCondition(token)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 手机号登录
    LoginByMobile ({ commit }, mobileLoginForm) {
      return new Promise((resolve, reject) => {
        loginByMobile(mobileLoginForm.phone, mobileLoginForm.code).then(response => {
          const data = response.data
          const token = data.data
          console.log(data)
          // 说明登录成功了，给vuex设置token，放到Cookie
          if (data.errorInfo === 'success' && token !== '') {
            commit('SET_TOKEN', token)
            setToken(token, mobileLoginForm.checked)
            // setConsumerCondition(token)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          const data = response.data
          // data.otherData !== 'notLogin' &&
          if (data.errorInfo === 'success') {
            sessionStorage.setItem('SET_USERINFO',JSON.stringify(data.data) )
            sessionStorage.setItem('SET_ISLOGIN', true)
          } else {
            // const _toPath = this
            // _toPath.$router.push({path: '/login'})
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut ({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then((response) => {
          commit('SET_TOKEN', '')
          commit('SET_USERINFO', '')
          commit('SET_ISLOGIN', false)
          removeToken()
          removeConsumerCondition()
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', '')
        commit('SET_ISLOGIN', false)
        removeToken()
        removeConsumerCondition()
        removeRedirectUrl()
        removePlatformUrl()
        sessionStorage.clear()
        resolve()
      })
    },
    // 导航高亮当前值
    SetIsActice ({ commit }, isActive) {
      return new Promise(resolve => {
        commit('SET_ISACTIVE', isActive)
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js